<template>
  <div class="page_settlementClaims ">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px" v-if="activeName=='first'">
            <el-form-item label="方案名称" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商" size="small">
              <el-select v-model="listQuery.name" placeholder="" size="small" clearable filterable>
                <el-option v-for="(item,index) in planList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保单号" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <el-breadcrumb-item>申报端</el-breadcrumb-item>
          <el-breadcrumb-item>报案理赔</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="background-color: #fff;">
        <tabs :name="name"></tabs>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="报案待审核(10)" name="1"></el-tab-pane>
          <el-tab-pane label="材料审核中(10)" name="2"></el-tab-pane>
          <el-tab-pane label="理赔中(10)" name="3"></el-tab-pane>
          <el-tab-pane label="已结案(10)" name="4"></el-tab-pane>
          <el-tab-pane label="已撤销(10)" name="5"></el-tab-pane>
        </el-tabs>

        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" v-if="activeName==1" @click="reportCase">&nbsp;报案</el-button>
          <el-button type="success" size="small" v-if="activeName==1 || activeName==2">&nbsp;发送短信</el-button>
          <el-button type="primary" size="small" v-if="activeName==1|| activeName==2">&nbsp;下载报案文档</el-button>
          <el-button type="success" size="small">&nbsp;导出</el-button>
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Name" label="服务商" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Name" label="案件号" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Name" label="项目名称" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="手机号码" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="工种" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="证件号码" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="方案名称" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="报案日期" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="影像件" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==2" label="资料最近提交时间" :show-overflow-tooltip="true" align="center" width="150px">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="材料收到时间" :show-overflow-tooltip="true" align="center" width="150px">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="材料提交保险公司时间" :show-overflow-tooltip="true" align="center" width="160px">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="结案时间" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="理赔进度" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="理赔打款去向" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="申请金额" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="结案金额" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==3 || activeName==4 || activeName == 5" label="申请理赔时间" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="出险说明" :show-overflow-tooltip="true" align="center" v-if="activeName==1 || activeName==2">
          </el-table-column>
          <el-table-column prop="Name" label="案件状态" :show-overflow-tooltip="true" align="center" v-if="activeName==1 || activeName==2">
          </el-table-column>
          <el-table-column prop="Name" v-if="activeName==1" label="报案人" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="备注" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="操作" align="center" fixed="right" min-width="180px">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-preventReClick v-if="activeName == '1' || activeName == '2' || activeName == '3'">撤销</el-button>
                <el-button type="text" v-preventReClick @click="editHandle('edit')" v-if="activeName == '1'">编辑</el-button>
                <el-button type="text" v-preventReClick @click="editHandle('read')">查看</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>


    <el-dialog :title="type == 'edit' ? '编辑' : '查看'" :visible.sync="showEditInfo" width="550px">
      <div class="editForm">
        <el-form :model="editForm" ref="editForm" label-width="130px" :disabled="type=='read'">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="editForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="证件号码" prop="name">
            <el-input v-model="editForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="name">
            <el-input v-model="editForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="出险日期" prop="name">
            <el-date-picker type="date" placeholder="" v-model="editForm.name" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="项目名称" prop="name">
            <el-input v-model="editForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="出险说明" prop="name">
            <el-input v-model="editForm.name" type="textarea" :autosize="{ minRows: 3}" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="name">
            <el-input v-model="editForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="name">
            <el-input v-model="editForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="name">
            <el-input v-model="editForm.name" type="textarea" :autosize="{ minRows: 3}" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditInfo = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="showEditInfo = false" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="报案" :visible.sync="showreportCase" width="800px">
      <el-steps :active="active" finish-status="success">
        <el-step title="人员信息" description="填写报案人员的基本信息"></el-step>
        <el-step title="上传影像件" description="上传报案相关影像件"></el-step>
        <el-step title="提交快递信息" description="提交理赔资料快递信息"></el-step>
      </el-steps>
      <div class="editForm caseForm">
        <el-form :model="caseForm" ref="caseForm" label-width="130px" v-if="active==0">
          <div class="formTitle">出险人信息</div>
          <el-form-item label="出险人姓名" prop="name">
            <el-input v-model="caseForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="证件号" prop="name">
            <el-input v-model="caseForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="name">
            <el-input v-model="caseForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="出险日期" prop="name">
            <el-date-picker type="date" placeholder="" v-model="caseForm.name" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="方案名称" prop="name">
            <el-select v-model="caseForm.name" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option v-for="(item,index) in planList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出险说明" prop="name">
            <el-input v-model="editForm.name" type="textarea" :autosize="{ minRows: 3}" style="width:300px" size="small"></el-input>
          </el-form-item>

          <div class="formTitle">经办人信息</div>
          <el-form-item label="联系人姓名" prop="name">
            <el-input v-model="caseForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="name">
            <el-input v-model="caseForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>

        <el-form :model="caseForm" ref="caseForm2" label-width="54px" v-if="active==1">
          <div style="height: 30px;"></div>
          <el-form-item label="影像件" prop="name">
            <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
              <el-button size="small" type="success">上传附件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>

        <el-form :model="caseForm" ref="caseForm3" label-width="130px" v-if="active==2">
          <div class="formTitle">物流信息</div>
          <el-form-item label="寄出日期" prop="name">
            <el-date-picker type="date" placeholder="" v-model="caseForm.name" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="快递公司" prop="name">
            <el-select v-model="caseForm.name" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option v-for="(item,index) in planList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="name">
            <el-input v-model="caseForm.name" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showreportCase = false" size="small">取 消</el-button>
        <el-button type="primary" style="margin-left:10px;" @click="nextStep('-')" size="small" v-if="active>0">上一步</el-button>
        <el-button type="primary" style="margin-left:10px;" @click="nextStep('add')" size="small" v-if="active==1">跳过</el-button>
        <el-button type="primary" style="margin-left:10px;" @click="nextStep('add')" size="small" v-if="active<2">下一步</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="showreportCase = false" size="small" v-if="active==2">提 交</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/declareTabs.vue";
  export default {
    components: {
      tabs
    },
    data() {
      return {
        name: '/settlementClaims',
        listQuery: {
          pageNum: 1,
          pageSize: 10
        },
        totalCount: 0,
        roletype: localStorage.loginRoletype,
        showDropScreen: -1,
        type: 'edit', //报增or报减
        activeName: '1',
        verifiedType: 'proSum', //项目汇总/人员明细
        returnType: 'all', //被退回 整批/单人
        planList: ['方案1', '方案2'], //服务商方案列表
        loading: false,
        tableData: [],
        editForm: {
          name: ''
        },
        ExcelSrc: {
          value: "",
          check: false,
          fileName: "",
        },
        showEditInfo: false, //编辑弹窗
        showreportCase: false, //报案弹窗
        active: 0, //步骤条
        caseForm: {
          name: '',
          OperatorName: '', //经办人
          OperatorTe: '', //经办人手机号
        },
        fileList: []
      }
    },
    created() {
      this.getInsureClaimList();
    },
    methods: {
      checkPermission,
      searchHandle() {},
      handleClick() {},
      //获取经办人信息
      getUserInfo() {
        let data = {
          mainuserid: "",
          useridr: Cookies.get("userid-b"),
        }
        xz.getauthJbUserDetailNew(data.useridr, data).then(res => {
          if (res.status == 'ok') {
            this.caseForm.OperatorName = res.msg.Username;
            this.caseForm.OperatorTe = res.msg.Strmobile;
          } else {
            this.caseForm.OperatorName = '';
            this.caseForm.OperatorTe = '';
          }
        })
      },
      //获取报案列表
      getInsureClaimList() {
        this.loading = true;
        xz.getInsureClaimList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.tableData = res.data.list;
            this.totalCount = res.data.Count;
          } else {
            this.$message.error('系统出错！');
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //文件读取
      success_handle(file, fileList) {
        const fileInput = file.raw;
        FUN.fileToBase64(fileInput).then(res => {
          if (res) {
            console.log(res)
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        })
      },
      handleRemove(file) {
        this.formData.DetailsUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      editHandle(type) {
        this.type = type;
        this.showEditInfo = true;
      },
      //报案
      reportCase() {
        this.active = 0;
        this.showreportCase = true;
      },
      //下一步
      nextStep(type) {
        if (type == 'add') {
          this.active++;
        } else {
          this.active--;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .caseForm {
    padding-left: 100px;
  }

  .formTitle {
    margin: 20px 0;
    font-size: 18px;
    font-weight: 500;
    color: #000;
  }
</style>
<style>
  .page_settlementClaims .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementClaims .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementClaims .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementClaims .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementClaims .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementClaims .editForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_settlementClaims .editForm .el-form-item__error {
    top: 34px;
  }
</style>